import { DEVICE_SET_READY, AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import api from '@/services/Api';

// ----------------------------- o

const state = {
  deviceReady: false,
  token: localStorage.getItem('access-token') ? localStorage.getItem('access-token') : '',
  deviceToken: localStorage.getItem('device_token') ? localStorage.getItem('device_token') : null,
  status: '',
  hasLoadedOnce: false
};

// ----------------------------- o

const getters = {
  isAuthenticated: state => !!state.token,
  getToken: state => state.token,
  deviceIsReady: state => state.deviceReady,
  // authStatus: state => state.status, // main loader moved to user module
};

// ----------------------------- o

const actions = {
  'AUTH_SAVE_DEVICE_TOKEN': ({commit, dispatch}, token) => {
    console.log('_________________AUTH_SAVE_DEVICE_TOKEN', token)
    commit('AUTH_SAVE_DEVICE_TOKEN', token);
    localStorage.setItem('device_token', token); // set local storage
    console.log('AUTH_SAVE_DEVICE_TOKEN', token)
  },
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      console.log('store AUTH_REQUEST')

      // get access token
      api.post('/authorization', user)
        .then(resp => {
          // set local storage
          localStorage.setItem('access-token', 'Bearer '+resp.data.data.access_token);
          // set api headers
          api.defaults.headers['Authorization'] = 'Bearer '+resp.data.data.access_token;
          commit(AUTH_SUCCESS, resp.data.data);
          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem('access-token');
          reject(err)
        })

    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('access-token');
      // localStorage.removeItem('fcm-token'); // TODO REFACTOR
      resolve()
    })
  }
};

// ----------------------------- o

const mutations = {
  'AUTH_SAVE_DEVICE_TOKEN': (state, payload) => {
    state.deviceToken = payload;
  },
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp.access_token;
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  },
  [DEVICE_SET_READY]: (state, value) => {
    state.deviceReady = value
  }
};

// ----------------------------- o

export default {
  state,
  getters,
  actions,
  mutations,
}
